import { useRequest } from 'ahooks'

import { toast } from '$app/utilities'

import { MobileOTPResendRequest } from '$api/types'
import { AnonymousAuthAPI } from '$api/anonymous-auth'

const { mobileOTPResend, errorMessageResolver, successResolver } =
  new AnonymousAuthAPI(null)

export const useMobileOTPResend = () => {
  const { loading, runAsync } = useRequest(mobileOTPResend, { manual: true })

  const resend = (data: MobileOTPResendRequest) => {
    return toast
      .promise(runAsync(data), {
        loading: 'Resending..',
        error: e => errorMessageResolver(e, 'Invalid credential'),
        success: 'OTP requested'
      })
      .unwrap()
      .then(successResolver)
  }

  return { resend, loading }
}

export default useMobileOTPResend
